import { render, staticRenderFns } from "./AppBtmBar.vue?vue&type=template&id=dcb081c8"
import script from "./AppBtmBar.vue?vue&type=script&lang=js"
export * from "./AppBtmBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports